import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { CreateEnrolementInput, IEnrolement, IInvoices, IUploadInvoice } from './enrole.interface';

const API_URI = `${environment.apiBaseUrl}/enrollment-form`;
const INVOICE_API_URI = `${environment.apiBaseUrl}/invoice`;

@Injectable({ providedIn: 'root' })
export class EnrolementService {
    http: HttpClient = inject(HttpClient);

    getAllEnrolements() {
        return this.http.get<IEnrolement[]>(API_URI);
    }

    createEnrolement(input: CreateEnrolementInput) {
        return this.http.post<IEnrolement>(`${API_URI}`, input);
    }

    getUserEnrolement(userId: string) {
        return this.http.get<IEnrolement>(`${API_URI}/${userId}`);
    }
    getSingleEnrolement(id: string) {
        return this.http.get<IEnrolement>(`${API_URI}/single/${id}`);
    }

    getAllInvoices() {
        return this.http.get<IInvoices[]>(INVOICE_API_URI + '/all');
    }

    uploadeInvoice(input: { employeeName: string; invoicesBase64: string[] }) {
        return this.http.post<string[]>(`${INVOICE_API_URI}/upload-invoice`, input);
    }

    submitInvoice(input: IUploadInvoice) {
        return this.http.post<IInvoices>(`${INVOICE_API_URI}`, input);
    }

    getSingleInvoice(id: string) {
        return this.http.get<IInvoices>(`${INVOICE_API_URI}/single/${id}`);
    }
}
